export default __webpack_public_path__ + "static/smellsLikeChocolate-2c5a25611cc49b062d4b3f7c8be64604.png";